import {lazy, Suspense} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import {useDeviceTypeUpdater} from "./utils/device-details/update-device-type";
import {
  EXAM_PAGE_ROUTES,
  ExamPageSection,
} from "./pages/exam/common/navigation/routes";
import NotFound from "./pages/not-found/NotFound";
import LoginDialog from "./features/login-dialog";
import ExamPage from "./pages/exam/common/ExamPage";
// import MockTestPage from "./pages/exam/common/section/mock-test/MockTestPage";
// import MockTestDetailsPage from "./pages/exam/common/section/mock-test/MockTestDetailsPage";
// import FeedbackPage from "./pages/exam/common/feedback/Feedback";
import LoadingUI from "./LoadingUI";
import LandingPage from "./pages/landing/LandingPage";
import Problemset from "./pages/exam/common/section/problemset/Problemset";
import ProblemsetSubjectIncomplete from "./pages/exam/common/section/problemset/ProblemsetSubjectIncomplete";
import ProblemsetChapterIncomplete from "./pages/exam/common/section/problemset/ProblemsetChapterIncomplete";
import ProblemDialog from "./features/problem-dialog";
// import ExamAttemptPage from "./pages/exam/common/section/attempt-exam/ExamAttemptPage";
// import ExamAnalysisPage from "./pages/exam/common/section/exam-analysis/ExamAnalysisPage";
const FeedbackPage = lazy(
  () => import("./pages/exam/common/feedback/Feedback"),
);
const MockTestDetailsPage = lazy(
  () => import("./pages/exam/common/section/mock-test/MockTestDetailsPage"),
);
const MockTestPage = lazy(
  () => import("./pages/exam/common/section/mock-test/MockTestPage"),
);
const ExamAttemptPage = lazy(
  () => import("./pages/exam/common/section/attempt-exam/ExamAttemptPage"),
);
const ExamAnalysisPage = lazy(
  () => import("./pages/exam/common/section/exam-analysis/ExamAnalysisPage"),
);

function App() {
  useDeviceTypeUpdater();

  return (
    <>
      <Suspense fallback={<LoadingUI />}>
        <LoginDialog />
        <Routes>
          <Route index element={<LandingPage />} />

          <Route path=":examPath" element={<ExamPage />}>
            <Route index element={<ProblemsetSubjectIncomplete />} />
            <Route
              path={EXAM_PAGE_ROUTES[ExamPageSection.PROBLEM_SET_SUBJECT]}
              element={<ProblemsetChapterIncomplete />}
            />
            <Route
              path={EXAM_PAGE_ROUTES[ExamPageSection.PROBLEM_SET_CHAPTER]}
              element={<Problemset />}
            />
            <Route
              path={EXAM_PAGE_ROUTES[ExamPageSection.PROBLEM_SET_QUESTION]}
              element={<ProblemDialog />}
            />
            <Route
              path={EXAM_PAGE_ROUTES[ExamPageSection.MOCK_TEST_INSTRUCTIONS]}
              element={<MockTestDetailsPage />}
            />
            <Route
              path={
                EXAM_PAGE_ROUTES[
                  ExamPageSection.MOCK_TEST_EXPLORE_WITH_CATEGORY
                ]
              }
              element={<MockTestPage />}
            />
            <Route
              path={EXAM_PAGE_ROUTES[ExamPageSection.MOCK_TEST_EXPLORE]}
              element={<MockTestPage />}
            />
            <Route path="*" element={<Navigate to={"."} />} />
          </Route>
          <Route
            path={`:examPath/${EXAM_PAGE_ROUTES[ExamPageSection.MOCK_TEST_ATTEMPT]}`}
            element={<ExamAttemptPage />}
          />
          <Route
            path={`:examPath/${EXAM_PAGE_ROUTES[ExamPageSection.MOCK_TEST_ANALYSIS]}`}
            element={<ExamAnalysisPage />}
          />
          <Route
            path={`:examPath/${EXAM_PAGE_ROUTES[ExamPageSection.MOCK_TEST_ATTEMPT_FEEDBACK]}`}
            element={<FeedbackPage />}
          />
          {/* Fallback route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
